// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordFiltersPopup__content-cbdd8b {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 8px 0px;
  overflow: hidden;
}

.KeywordFiltersPopup__header-bc7dbc {
  padding: 16px 24px 8px 24px;
}

.KeywordFiltersPopup__list-container-abb629 {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.KeywordFiltersPopup__list-dd3bf9 {
  flex: 1;
  overflow-y: auto;
}

.KeywordFiltersPopup__add-container-dd772f {
  display: flex;
}

.KeywordFiltersPopup__add-input-dbde5c {
  flex: 1;
}

.KeywordFiltersPopup__add-button-a230d0 {
  margin-inline-start: 8px;
}

.KeywordFiltersPopup__description-f70975 {
  margin-bottom: 8px;
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  color: var(--base-80);
}

.KeywordFiltersPopup__divider-a28d8f {
  background-color: var(--base-15);
  margin-top: 10px;
  margin-bottom: 10px;
  height: 12px;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/KeywordFiltersPopup/KeywordFiltersPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 8px 0px;\n  overflow: hidden;\n}\n\n.header {\n  padding: 16px 24px 8px 24px;\n}\n\n.list-container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.list {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.add-container {\n  display: flex;\n}\n\n.add-input {\n  flex: 1;\n}\n\n.add-button {\n  margin-inline-start: 8px;\n}\n\n.description {\n  margin-bottom: 8px;\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  color: var(--base-80);\n}\n\n.divider {\n  background-color: var(--base-15);\n  margin-top: 10px;\n  margin-bottom: 10px;\n  height: 12px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `KeywordFiltersPopup__content-cbdd8b`,
	"header": `KeywordFiltersPopup__header-bc7dbc`,
	"list-container": `KeywordFiltersPopup__list-container-abb629`,
	"listContainer": `KeywordFiltersPopup__list-container-abb629`,
	"list": `KeywordFiltersPopup__list-dd3bf9`,
	"add-container": `KeywordFiltersPopup__add-container-dd772f`,
	"addContainer": `KeywordFiltersPopup__add-container-dd772f`,
	"add-input": `KeywordFiltersPopup__add-input-dbde5c`,
	"addInput": `KeywordFiltersPopup__add-input-dbde5c`,
	"add-button": `KeywordFiltersPopup__add-button-a230d0`,
	"addButton": `KeywordFiltersPopup__add-button-a230d0`,
	"description": `KeywordFiltersPopup__description-f70975`,
	"divider": `KeywordFiltersPopup__divider-a28d8f`
};
module.exports = ___CSS_LOADER_EXPORT___;
